import { clearAllPageDocuments } from '../blocks/page-cache';
import { invalidateLinkablePagesCache } from '../blocks/page-link-search';
import { clearLastPageId } from '../navigation/last-page';
import { clearRecentPages } from '../navigation/recent-pages';
import { getDevAuthHeaders } from '../auth/dev-impersonation';
import { getNativeBearerAuthHeaders } from '../auth/native-api-auth';
import { getApiBaseUrl } from '../env';

export const WORKSPACE_WIPED_EVENT = 'couplespace:workspace-wiped';

async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const base = getApiBaseUrl().replace(/\/$/, '');
  return fetch(`${base}${path}`, {
    ...init,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...getDevAuthHeaders(),
      ...(await getNativeBearerAuthHeaders()),
      ...init?.headers,
    },
  });
}

async function parseApiError(res: Response, path: string): Promise<never> {
  const text = await res.text();
  let detail = text || res.statusText;
  try {
    const json = JSON.parse(text) as { error?: { message?: string } };
    if (json.error?.message) {
      detail = json.error.message;
    }
  } catch {
    // plain text body
  }
  throw new Error(`${res.status} ${path}: ${detail}`);
}

export function resetClientAfterWorkspaceWipe(): void {
  void clearLastPageId();
  clearRecentPages();
  clearAllPageDocuments();
  invalidateLinkablePagesCache();
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(WORKSPACE_WIPED_EVENT));
  }
}

/** Dev-only: wipe all workspace content for every member and re-seed empty roots. */
export async function cleanupAllUserData(): Promise<void> {
  const path = '/rpc/dev/cleanup-workspace';
  const res = await apiFetch(path, {
    method: 'POST',
    body: JSON.stringify({ confirm: true }),
  });
  if (!res.ok) {
    await parseApiError(res, path);
  }
  resetClientAfterWorkspaceWipe();
}
